/**
 * Centralized API URL configuration.
 * All API services should import URLs from here instead of reading env vars directly.
 *
 * In development, requests use relative paths (/api, /public-api) that the Vite
 * dev server proxies to the real backend. In production, full API Gateway URLs
 * from env vars are used directly. See docs/frontend/vite-proxy.md for details.
 */

const isDev = import.meta.env.DEV;

/** Authenticated API (API Gateway with Cognito authorizer) */
export const API_URL = isDev
  ? '/api'
  : (import.meta.env.REACT_APP_ADD_API_URL || '');

/** Raw Contact API URL (includes /contact path suffix) */
export const CONTACT_API_URL = isDev
  ? '/public-api/contact'
  : (import.meta.env.REACT_APP_CONTACT_API_URL || '');

/** Public API base (unauthenticated, /contact suffix stripped) */
export const PUBLIC_API_URL = isDev
  ? '/public-api'
  : (CONTACT_API_URL.replace(/\/contact$/, ''));
